import { MultiColumnAutoCompleteStoreContext } from './MultiColumnAutoCompleteStoreContext';

export const useMultiColumnAutoCompleteStore =
  MultiColumnAutoCompleteStoreContext.useStore;
